module.exports = __webpack_public_path__ + "static/media/8OLA25.59548a68.jpg";